export default __webpack_public_path__ + "static/media/img_health_guide@3x.6f76883b.png";